import React, { useRef, useState } from 'react';
import { Button, Col, Row, Spinner, ProgressBar } from '@themesberg/react-bootstrap';
import useUploadApk from './hooks/useUploadApk';
import { toast } from "../../components/Toast";
import ApkTable from "./ApkConfigTable";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-regular-svg-icons';

function UploadApk() {
  const {
    loading,
    data,
    handleFileChange,
    isAddApkLoading,
    progress,
    isLoadingGetApk,
    apkListing
  } = useUploadApk();

  const [isDragActive, setIsDragActive] = useState(false);
  const fileInputRef = useRef(null);

  // Handle file selection from input or drop
  const processFile = (file) => {
    if (!file.name.endsWith('.apk')) {
      toast("Only .apk extension files are allowed", "error");
      return;
    }
    handleFileChange({ target: { files: [file] } });
  };

  // Drag-and-drop events
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      processFile(e.dataTransfer.files[0]);
      e.dataTransfer.clearData();
    }
  };

  // Click to open hidden input
  const handleClickSelectFile = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <>
      <Row className="mt-3">
        <Col sm={12} className="text-center mt-3">
          <div
            className={`drag-drop-zone ${isDragActive ? 'drag-over' : ''}`}
            style={{
              border: '2px dashed #007bff',
              borderRadius: '8px',
              padding: '30px',
              cursor: 'pointer',
              backgroundColor: isDragActive ? '#e9f5ff' : '#fafafa',
              transition: 'background-color 0.3s ease'
            }}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            onClick={handleClickSelectFile}
          >
            <input
              type="file"
              accept=".apk"
              style={{ display: 'none' }}
              ref={fileInputRef}
              onChange={(e) => {
                if (e.target.files && e.target.files.length > 0) {
                  processFile(e.target.files[0]);
                }
              }}
            />

            {isAddApkLoading ? (
              <>
                <p>Uploading File ...</p>
                <ProgressBar
                  now={progress}
                  label={`${progress}%`}
                  animated
                  striped
                  style={{ height: '15px', backgroundColor: '#e9ecef' }}
                  variant=""
                  className="custom-progress"
                />
              </>
            )  : <p className='mb-0'> Upload an APK file here</p>}

            <Button
              variant="primary"
              className="mt-3"
              disabled={isAddApkLoading}
              onClick={(e) => {
                e.stopPropagation();
                handleClickSelectFile();
              }}
            >
              {isAddApkLoading ? (
                <>
                  Uploading 
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    style={{ marginLeft: '8px' }}
                  />
                </>
              ) : (
                "Upload File"
              )}
            </Button>
          </div>
        </Col>
      </Row>
      <ApkTable loading={isLoadingGetApk} data={apkListing} />
    </>
  );
}

export default UploadApk;
